import { SHContainer, SHStack } from "@components/design-systems";
import { TableAnalysisCellSkeleton } from "@components/skeletons/layouts/platform-analysis/table-analysis/TableAnalysisCellSkeleton";
import { StepNameSkeleton } from "@components/skeletons/layouts/stepper/StepNameSkeleton";
import { useTheme } from "@mui/material";

export const FeatureAnalysisSkeleton = () => {
  const windowHeight = window.innerHeight;
  const breakpoints = useTheme().breakpoints;
  return (
    <SHContainer
      maxWidth="xl"
      sx={{
        px: { xs: "16px", lg: "100px" },
        maxHeight: windowHeight - 180,
        overflow: "hidden",
      }}
    >
      <SHStack spacing={3} marginTop={3}>
        <SHStack width={"100%"} alignItems={"center"}>
          <SHStack width={"100%"} maxWidth={breakpoints.values.lg}>
            <StepNameSkeleton delay={false} />
          </SHStack>
        </SHStack>

        <SHStack spacing={1.5} maxWidth={"95vw"} overflow={"hidden"}>
          <SHStack
            width={"100%"}
            direction={"row"}
            alignItems={"center"}
            sx={{ overflow: "hidden" }}
          >
            <TableAnalysisCellSkeleton isTableHead isFirstColumn />
            {Array.from(Array(4).keys()).map((index) => (
              <TableAnalysisCellSkeleton key={index} isTableHead />
            ))}
            <TableAnalysisCellSkeleton isTableHead isLastColumn />
          </SHStack>

          <SHStack
            direction={"column"}
            alignItems={"center"}
            sx={{ overflow: "hidden" }}
          >
            {Array.from(Array(8).keys()).map((index) => (
              <SHStack key={index} width={"100%"} height={54} direction={"row"}>
                <TableAnalysisCellSkeleton isFirstColumn />
                {Array.from(Array(4).keys()).map((index) => (
                  <TableAnalysisCellSkeleton key={index} />
                ))}
                <TableAnalysisCellSkeleton isLastColumn />
              </SHStack>
            ))}
          </SHStack>
        </SHStack>
      </SHStack>
    </SHContainer>
  );
};
